require.context("./images", true, /\.(ico|jpe?g|png|gif|svg|xml)$/i);

require("./styles.js");
require("./scripts.js");
